import { Injectable } from '@angular/core';
import { HttpClientService } from '../../../../lib/http/http-client.service';

@Injectable()
export class BuyerInvitationService {

  constructor(private http: HttpClientService) { }

  public getCommunityListForBuyerMailNotification() {
    return this.http.get('/BuyerMailNotification/GetCommunityListForBuyerMailNotification');
  }

  public getBuyerInformationFromCommunityID(communityID: number) {
    return this.http.get('/BuyerMailNotification/GetBuyerInformationFromCommunityID?communityID=' + communityID);
  }

  public sendMailToBuyer(buyerID: number,CommunityLotID : number) {
    return this.http.get('/BuyerMailNotification/SendMailToBuyer?buyerID=' + buyerID+ "&CommunityLotID=" + CommunityLotID);
  }

  




}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/buyer-upload-section/services/buyer-invitation.service.ts